module.exports = __webpack_public_path__ + "img/baffleBottom.476fec0b.png";